<button
  type="button"
  pButton
  pRipple
  icon="pi pi-file-pdf"
  (click)="onExportPdf()"
  pTooltip="Export PDF"
  tooltipPosition="bottom"
  class="p-button-text p-button-plain p-button-lg tool-bar-pbutton"></button>
